module.exports = __webpack_public_path__ + "img/gif.a6776988.svg";